/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthGoogleAccessTokenResponse } from './AuthGoogleAccessTokenResponse';

export type AuthGoogleAccessTokenResponseApiRespoonse = {
    data?: AuthGoogleAccessTokenResponse;
    status?: AuthGoogleAccessTokenResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AuthGoogleAccessTokenResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

